document.addEventListener("DOMContentLoaded", async () => {
    const { DotLottie } = await import("https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm");

    function loadAnimation(canvasSelector, src) {
        const canvas = document.querySelector(canvasSelector);
        if (!canvas) {
            return;
        }

        return new DotLottie({
            canvas: canvas,
            src: src,
            loop: true,
            speed: 0.2,
            autoplay: true,
            layout: {
                fit: "cover",
                align: [0, 0],
            },
            renderConfig: {
                preserveAspectRatio: "xMidYMid slice",
            },
        });
    }

    // Charger toutes les animations si les éléments existent
    if (document.querySelector("#dotlottie-canvas")) {
        loadAnimation("#dotlottie-canvas", "/wp-content/themes/customtheme/assets/icons/gradient_blue.lottie");
    }

    if (document.querySelector("#dotlottie-ref-canvas")) {
        loadAnimation("#dotlottie-ref-canvas", "/wp-content/themes/customtheme/assets/icons/gradient_pink.lottie");
    }
});
